
import notificationStore from "../NotificationStore";
import { ActionType } from ".";


export class RequestActions {
  // AJAX handlers
  static getStartedRequests() {
    return notificationStore.getState();
  }

  static requestStarted(abortController: AbortController) {
    notificationStore.dispatch({type: ActionType.REQUEST_START, data: abortController});
  }

  static requestStopped(abortController: AbortController) {
    notificationStore.dispatch({type: ActionType.REQUEST_END, data: abortController});
  }
  // EOF AJAX handlers
}